// Create an audio context lazily to avoid issues with browser autoplay policies
let audioContext: AudioContext | null = null;
let audioInitialized = false;

const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
};

// Generate a short notification sound
const generateNotificationSound = async () => {
  try {
    // Try to initialize audio if not already done
    if (!audioInitialized) {
      await initializeAudio();
    }
    
    const context = getAudioContext();
    
    // Resume context if it's in suspended state
    if (context.state === 'suspended') {
      await context.resume();
    }

    const oscillator = context.createOscillator();
    const gainNode = context.createGain();

    // Configure sound
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(587.33, context.currentTime); // D5 note
    
    // Configure volume envelope
    gainNode.gain.setValueAtTime(0, context.currentTime);
    gainNode.gain.linearRampToValueAtTime(0.2, context.currentTime + 0.01);
    gainNode.gain.linearRampToValueAtTime(0, context.currentTime + 0.2);

    // Connect nodes
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);

    // Play sound
    oscillator.start(context.currentTime);
    oscillator.stop(context.currentTime + 0.2);
  } catch (error) {
    console.warn('Failed to play notification sound:', error);
  }
};

export const playNotificationSound = async () => {
  try {
    await generateNotificationSound();
  } catch (error) {
    console.warn('Failed to play notification sound:', error);
  }
};

// Initialize audio context on user interaction
export const initializeAudio = async () => {
  try {
    const context = getAudioContext();
    if (context.state === 'suspended') {
      await context.resume();
    }
    audioInitialized = true;
    return true;
  } catch (error) {
    console.warn('Failed to initialize audio:', error);
    return false;
  }
};

// Add event listeners to initialize audio on user interaction
export const setupAudioContextEvents = () => {
  if (typeof window !== 'undefined') {
    const userInteractionEvents = ['click', 'touchstart', 'keydown'];
    
    const handleUserInteraction = async () => {
      if (!audioInitialized) {
        await initializeAudio();
        
        // Remove event listeners once initialized
        userInteractionEvents.forEach(event => {
          window.removeEventListener(event, handleUserInteraction);
        });
      }
    };
    
    // Add event listeners for user interactions
    userInteractionEvents.forEach(event => {
      window.addEventListener(event, handleUserInteraction);
    });
  }
};
